import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import UploadButtons from "../../../CustomComponent/UploadButton";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import content from "./instructioncontent";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getMarkListData } from "../../../../service/MarkingServices";
import { getSlotListData } from "../../../../service/services";
import instructioncontent from "../AddExam/instructioncontent";
import instructioncontentJeeMain from "../AddExam/instructioncontentJeeMain";
import instructioncontentSsc from "../AddExam/instructioncontentSsc";
import instructioncontentIpmat from "../AddExam/instructioncontentIpmat";
import QuestionPickTable from "../AddExam/QuestionPickTable";
import { sanitizeInput } from "../../../../Utils/validationUtils";

const convertImageToBase64 = async (url) => {
  const response = await axios.get(url, { responseType: "blob" });
  const blob = response.data;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

function EditExamForm() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { rowId } = useParams();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  function convertToHtml(languageContent) {
    let htmlContent = "";

    for (let i = 0; i < languageContent.length; i++) {
      let section = languageContent[i];
      htmlContent += `<h2>${section.superhead}</h2>`;
      htmlContent += `<h3>${section.genhead}</h3>`;
      htmlContent += `<p style="color: red;">${section.rednote}</p>`;
      htmlContent += `<p>${section.agreement}</p>`;

      for (let j = 0; j < section.gencont.length; j++) {
        let item = section.gencont[j];
        htmlContent += `<div><b>${item.id}.</b> ${item.title}`;

        if (item.children) {
          htmlContent += "<ul>";
          for (let k = 0; k < item.children.length; k++) {
            let child = item.children[k];
            htmlContent += `<li>${child.title}</li>`;
          }
          htmlContent += "</ul>";
        }

        htmlContent += "</div>";
      }
    }

    return htmlContent;
  }

  const instructionsHtml = convertToHtml(content);

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const initialData = {
    center_id: "",
    course_id: "",
    batch_ids: "",
    exam_name: "",
    language: ["en"],
    question_count: "",
    total_score: "",
    question_shuffle: "no",
    option_shuffle: "no",
    negative_marking: "no",
    is_submit_on_time: "no",
    negative_marking_score: "",
    total_question: "",
    exam_instant_result: "no",
    exam_pin: "",
    exam_instructions: {
      // en: convertToHtml(content.en),
      // hi: convertToHtml(content.hi),
      en: "",
      hi: "",
    },
    genral_instruction: {
      // en: convertToHtml(content.en),
      // hi: convertToHtml(content.hi),
      en: "",
      hi: "",
    },
    duration: "",
    start_date: "",
    start_time: "",
    end_time: "",
    slot_value: "",
    marking_system: "",
    exam_template: "",
    exam_format: "",
    file: null,
    enable_submit: "0",
    randomized_question_pick: "no",
    time_bound: "no",
    calculator_enable: "yes",
    before_instruction: "no",
    section_count: [],
    center_feedback: "no",
    keyboard_enable: "no",
  };
  const [questionMarkSystem, setQuestionMarkSystem] = useState("same");
  const [formDetails, setFormDetails] = useState(initialData);
  const [examName, setExamName] = useState("");
  const [paperCode, setPaperCode] = useState("");
  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedSubjectName, setSelectedSubjectName] = useState([]);
  const [selectedSubjectSLength, setSelectedSubjectSLength] = useState(0);

  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [thumbnailImagePreview, setThumbnailImagePreview] = useState(null);
  const [examTempalteData, setExamTemplateData] = useState([]);
  const [showSubjectWiseDuration, setShowSubjectWiseDuration] = useState("yes");
  const [subjectDurations, setSubjectDurations] = useState([]);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [slotDropdownFieldData, setSlotDropdownFieldData] = useState([]);
  const [pinEnable, setPinEnable] = useState("on");

  const handleLanguageMenuToggle = () => {
    setLanguageMenuOpen(!languageMenuOpen);
  };
  console.log("subjectDurations", subjectDurations);
  const handleSubjectDurationChange = (subjectId, value) => {
    setSubjectDurations((prev) => {
      const existingIndex = (prev || []).findIndex(
        (item) => String(item.subject_id) === String(subjectId),
      );

      const parsedValue = value === "" ? "" : parseInt(value) || 0;

      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          duration: parsedValue,
        };
        return updated;
      } else {
        return [
          ...(prev || []),
          { subject_id: subjectId, duration: parsedValue },
        ];
      }
    });
  };
  const [perQuestionMarks, setPerQuestionMarks] = useState("0");
  useEffect(() => {
    const fetchSlots = async () => {
      try {
        if (!decryptedToken) return;
        const data = await getSlotListData();
        setSlotDropdownFieldData(data);
      } catch (err) {
        console.error("Failed to load slots", err);
      }
    };

    fetchSlots();
  }, []);
  useEffect(() => {
    const fetchSlots = async () => {
      try {
        if (!decryptedToken) return;
        const data = await getMarkListData();
        setExamTemplateData(data?.markingsystem);
      } catch (err) {
        console.error("Failed to load slots", err); // Error logging
      }
    };
    fetchSlots();
  }, []);
  useEffect(() => {
    if (formDetails.question_count && formDetails.total_score) {
      const calculatedMarks =
        formDetails.total_score / formDetails.question_count;
      setPerQuestionMarks(calculatedMarks.toFixed(2));
    }
  }, [formDetails.question_count, formDetails.total_score]);
  useEffect(() => {
    if (
      formDetails.time_bound === "yes" &&
      formDetails.start_time &&
      formDetails.duration
    ) {
      const [hours, minutes] = formDetails.start_time.split(":").map(Number);
      const durationMinutes = parseInt(formDetails.duration) || 0;

      const startDate = new Date();
      startDate.setHours(hours, minutes, 0, 0);

      const endDate = new Date(startDate.getTime() + durationMinutes * 60000);

      const endHours = String(endDate.getHours()).padStart(2, "0");
      const endMinutes = String(endDate.getMinutes()).padStart(2, "0");
      const calculatedEndTime = `${endHours}:${endMinutes}`;

      if (formDetails.end_time !== calculatedEndTime) {
        setFormDetails((prev) => ({
          ...prev,
          end_time: calculatedEndTime,
        }));
      }
    }
  }, [formDetails.time_bound, formDetails.start_time, formDetails.duration]);

  const isInitialRender = useRef(true);
  useEffect(() => {
    if (formDetails?.question_mark_system === "different") {
      setFormDetails((prevFormDetails) => ({
        ...prevFormDetails,
        negative_marking: "no",
      }));
    }
  }, [formDetails.question_mark_system]);
  useEffect(() => {
    const convertAllImagesToBase64 = async (htmlContent) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const imgTags = doc.querySelectorAll("img");

      for (const img of imgTags) {
        const src = img.getAttribute("src");
        if (src && !src.startsWith("data:")) {
          const base64 = await convertImageToBase64(src);
          img.setAttribute("src", base64);
        }
      }

      return doc.body.innerHTML;
    };

    const handleInstructions = async () => {
      if (!formDetails.exam_template) return;

      let selectedInstructions;
      switch (formDetails.exam_template.toLowerCase()) {
        case "iit":
          selectedInstructions = {
            en: instructioncontentJeeMain.en,
            hi: instructioncontentJeeMain.hi,
          };
          break;
        case "ssc/railway":
          selectedInstructions = {
            en: instructioncontentSsc.en,
            hi: instructioncontentSsc.hi,
          };
          break;
        case "ipmat":
          selectedInstructions = {
            en: instructioncontentIpmat.en,
            hi: instructioncontentIpmat.hi,
          };
          break;
        default:
          selectedInstructions = {
            en: instructioncontent.en,
            hi: instructioncontent.hi,
          };
      }

      const [en, hi] = await Promise.all([
        convertAllImagesToBase64(selectedInstructions.en),
        convertAllImagesToBase64(selectedInstructions.hi),
      ]);
      // setFormDetails((prev) => ({
      //   ...prev,
      //   exam_instructions: { en, hi },
      // }));

      setFormDetails((prev) => {
        if (isInitialRender.current) {
          return prev;
        }
        return {
          ...prev,
          exam_instructions: { en, hi },
        };
      });
      isInitialRender.current = false;
      // },
    };

    handleInstructions();
  }, [formDetails.exam_template]);

  const handleExamFormatChange = (format) => {
    let autofillData = null;

    if (format === "NEET") {
      autofillData = {
        question_count: "180",
        total_score: "720",
        questionMarkSystem: "same",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Mains") {
      autofillData = {
        question_count: "75",
        total_score: "300",
        questionMarkSystem: "same",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(48)") {
      autofillData = {
        question_count: "48",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(51)") {
      autofillData = {
        question_count: "51",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(54)") {
      autofillData = {
        question_count: "54",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(57)") {
      autofillData = {
        question_count: "57",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    }

    if (autofillData) {
      setQuestionMarkSystem(autofillData.questionMarkSystem);
      const calculated =
        Number(autofillData.total_score) / Number(autofillData.question_count);
      setPerQuestionMarks(calculated.toFixed(2));

      setFormDetails((prev) => ({
        ...prev,
        exam_format: format,
        question_count: autofillData.question_count,
        total_score: autofillData.total_score,
        negative_marking: autofillData.negative_marking,
        negative_marking_score: autofillData.negative_marking_score,
      }));
    } else {
      setQuestionMarkSystem("same");
      setPerQuestionMarks("0");
      setFormDetails((prev) => ({
        ...prev,
        exam_format: format || "",
        question_count: "",
        total_score: "",
        negative_marking: "no",
        negative_marking_score: "",
      }));
    }
  };

  const handleQuestionMarkSystemChange = (event) => {
    setShowSubjectWiseDuration(event.target.value);
  };

  const quillModules = {
    toolbar: [
      [
        "bold",
        "italic",
        "underline",
        "strike",
        { script: "sub" },
        { script: "super" },
        { color: [] },
        { background: [] },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["code-block"],
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "list",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "link",
    "blockquote",
    "code-block",
    "align",
    "image",
  ];

  function isDecimal(num) {
    const decimal = num % 1;
    return decimal !== 0;
  }
  const handleFormChange = (fieldName, value) => {
    if (fieldName === "end_time") {
      if (formDetails.start_time && value && value <= formDetails.start_time) {
        toast.warn("End time must be after start time.");
        setFormDetails((prev) => ({
          ...prev,
          end_time: "",
        }));
        return;
      }
    }

    if (fieldName === "start_time") {
      if (formDetails.end_time && value && formDetails.end_time <= value) {
        toast.warn("Start time cannot be after end time. Please reselect end time.");
        setFormDetails((prev) => ({
          ...prev,
          start_time: value,
          end_time: "",
        }));
        return;
      }
    }

    const updatedForm = {
      ...formDetails,
      [fieldName]:
        fieldName === "language" && typeof value === "string"
          ? value.split(",")
          : value,
    };

    // Auto-calculate per question marks
    if (updatedForm.question_count && updatedForm.total_score) {
      const calculated = updatedForm.total_score / updatedForm.question_count;
      setPerQuestionMarks(calculated.toFixed(2));
    }

    if (fieldName === "language") {
      const languages = updatedForm.language;
      const newInstructions = { ...formDetails.exam_instructions };
      const newGeneralInstructions = { ...formDetails.genral_instruction };
      languages.forEach((lang) => {
        if (!newInstructions[lang]) {
          newInstructions[lang] = "";
        }
        if (!newGeneralInstructions[lang]) {
          newGeneralInstructions[lang] = "";
        }
      });
      setFormDetails((prev) => ({
        ...prev,
        [fieldName]: languages,
        exam_instructions: newInstructions,
        genral_instruction: newGeneralInstructions,
      }));
    } else {
      setFormDetails((prev) => {
        const newForm = { ...prev, [fieldName]: value };
        if (fieldName === "question_mark_system" && value === "different") {
          newForm.negative_marking = "no";
        }
        if (fieldName === "exam_template" && value !== "ssc/railway") {
          newForm.exam_format = "";
        }
        return newForm;
      });
    }
  };

  const handleThumbnailImageChange = (image) => {
    setThumbnailImage(image);
  };

  const handleCourceChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  const handleBatchChange = (event) => {
    setSelectedBatch(event.target.value);
  };

  const handleSubjectChange = (event, newValue) => {
    const selectedIds = newValue.map((subject) => subject.id);
    setSelectedSubject(selectedIds);
    setSelectedSubjectName(newValue.map((subject) => subject));
    setSubjectDurations((prev) =>
      (prev || []).filter((item) =>
        selectedIds.some((id) => String(id) === String(item.subject_id))
      )
    );
  };

  const handleCenterChange = (event, newValue) => {
    setSelectedCenter(newValue.map((center) => center.id));
  };

  const handleCancel = () => {
    navigate("/admin/exam");
  };
  console.log(
    "selectedSubject",
    selectedSubject,
    selectedBatch,
    batches?.length,
    subjects?.length,
  );
  const validateSectionWiseCount = (sectionWiseCount) => {
    if (sectionWiseCount.length !== selectedSubjectSLength) {
      toast.warning("Please enter Question Count for all sections.");
      return true;
    }

    let totalQuestionSum = 0;
    let pickQuestionSum = 0;

    for (let item of sectionWiseCount) {
      if (
        item.total_question_count === "" ||
        item.total_question_count === undefined
      ) {
        toast.warning("Please enter Total Question Count for all sections.");
        return true;
      }

      if (
        item.pick_question_count === "" ||
        item.pick_question_count === undefined
      ) {
        toast.warning("Please enter Pick Question Count for all sections.");
        return true;
      }

      if (item.pick_question_count > item.total_question_count) {
        toast.warning(
          "Pick Question Count cannot be greater than Total Question Count.",
        );
        return true;
      }

      totalQuestionSum += Number(item.total_question_count);
      pickQuestionSum += Number(item.pick_question_count);
    }
    console.log(
      "totalQuestionSum !== Number(formDetails.total_question",
      totalQuestionSum,
      Number(formDetails.total_question),
    );
    if (totalQuestionSum !== Number(formDetails.total_question)) {
      toast.warning(
        "Total Question of all sections must equal Total Question Count.",
      );
      return true;
    }

    if (pickQuestionSum !== Number(formDetails.question_count)) {
      toast.warning(
        "Pick Question of all sections must equal Pick Question Count.",
      );
      return true;
    }

    return false;
  };

  const handleFormSubmit = async () => {
    if (!examName.trim()) {
      toast.warn("Please enter an exam name.");
      return;
    }

    if (!selectedCourse) {
      toast.warn("Please select a course.");
      return;
    }

    if (!selectedBatch || selectedBatch.length === 0 || batches?.length === 0) {
      toast.warn("Please select a batch.");
      return;
    }

    if (
      !selectedSubject ||
      selectedSubject.length === 0 ||
      subjects?.length === 0
    ) {
      toast.warn("Please select at least one subject.");
      return;
    }

    if (!formDetails.language || formDetails.language.length === 0) {
      toast.warn("Please select at least one language.");
      return;
    }

    if (!formDetails?.question_count) {
      toast.warn(
        `Please enter the ${formDetails?.randomized_question_pick === "yes"
          ? "number of pick questions."
          : "number of questions."
        }`,
      );
      return;
    }

    if (
      formDetails?.randomized_question_pick === "yes" &&
      !formDetails.total_question
    ) {
      toast.warn(`Please enter the number of total question count`);
      return;
    }

    // 🔍 Subject-wise Question Count VALIDATION
    if (
      formDetails.randomized_question_pick === "yes" &&
      formDetails.exam_template === "default"
    ) {
      const subjectCounts = formDetails.subject_question_count || [];
      const selectedSubjectsList = selectedSubjectName || [];

      // 1️⃣ Validate each subject count
      for (const sub of selectedSubjectsList) {
        const record = subjectCounts.find((item) => item.subject_id === sub.id);

        if (!record || !record.count || Number(record.count) <= 0) {
          toast.warn(
            `Please enter valid question count for ${sub.subject_name}.`,
          );
          return;
        }
      }

      // 2️⃣ Calculate total
      const totalFromSubjects = subjectCounts
        .map((item) => Number(item.count))
        .reduce((acc, n) => acc + n, 0);

      if (totalFromSubjects !== Number(formDetails.question_count)) {
        toast.warn(
          `Total subject-wise question count (${totalFromSubjects}) must match Question Count (${formDetails.question_count}).`,
        );
        return;
      }
    }

    if (
      formDetails.randomized_question_pick === "yes" &&
      (formDetails.exam_template === "ssc/railway" ||
        formDetails.exam_template === "ipmat") &&
      validateSectionWiseCount(formDetails?.section_count)
    ) {
      return;
    }

    if (!formDetails.total_score) {
      toast.warn("Please enter the total score.");
      return;
    }
    if (showSubjectWiseDuration === "yes" && formDetails.exam_template === 'ipmat') {
      const activeDurations = (subjectDurations || []).filter((item) =>
        selectedSubject.some((subId) => String(subId) === String(item.subject_id))
      );

      // Check if durations are provided for all selected subjects
      const missingOrInvalidSubjects = [];
      selectedSubject.forEach((subId) => {
        const item = activeDurations.find(
          (d) => String(d.subject_id) === String(subId)
        );
        const subject = subjects.find((sub) => String(sub.id) === String(subId));
        const subjectName = subject ? subject.subject_name : "Subject";

        if (!item || item.duration === "" || item.duration === undefined || item.duration === null || isNaN(item.duration) || Number(item.duration) <= 0) {
          missingOrInvalidSubjects.push(subjectName);
        }
      });

      if (missingOrInvalidSubjects.length > 0) {
        toast.warn(
          `Please enter valid duration for all selected subjects: ${missingOrInvalidSubjects.join(", ")}`,
        );
        return;
      }
    }
    if (
      formDetails.negative_marking == "yes" &&
      (formDetails.negative_marking_score.length === 0 ||
        formDetails.negative_marking_score == -0)
    ) {
      if (formDetails.negative_marking_score == -0) {
        toast.warn("Please Add a Negetive Marking Grater Then 0.");
      } else {
        toast.warn("Please Add a Negetive Marking.");
      }
      return;
    }
    if (!formDetails.exam_pin && pinEnable === "on") {
      toast.warn("Please enter the exam pin.");
      return;
    }

    if (!formDetails.duration) {
      toast.warn("Please enter the duration of the exam.");
      return;
    }
    if (!selectedCenter || selectedCenter.length === 0) {
      toast.warn("Please select at least one center.");
      return;
    }
    if (!formDetails.exam_template) {
      toast.warn("Please select a Exam Template.");
      return;
    }
    if (
      formDetails.exam_template === "ssc/railway" &&
      !formDetails.exam_format
    ) {
      toast.warn("Please select an Exam Format.");
      return;
    }
    // if (!formDetails.slot_value) {
    //   toast.warn("Please select a Exam Template.");
    //   return;
    // }
    if (!formDetails.start_date) {
      toast.warn("Please select a start date.");
      return;
    }
    if (!formDetails.start_time) {
      toast.warn("Please select a start time.");
      return;
    }
    if (!formDetails.end_time) {
      toast.warn("Please select a end time.");
      return;
    }
    if (formDetails.end_time <= formDetails.start_time) {
      toast.warn("End time must be after start time.");
      return;
    }

    if (questionMarkSystem === "same" && isDecimal(perQuestionMarks)) {
      toast.warn("Per Question Mark must be a whole number.");
      return;
    }
    // if (!formDetails.slot_value) {
    //   toast.warn("Please select a Slot.");
    //   return;
    // }
    try {
      const formData = new FormData();
      const examData = {
        id: rowId,
        center_id: selectedCenter,
        course_ids: selectedCourse,
        batch_ids: selectedBatch,
        subjects: selectedSubject,
        exam_name: examName,
        paper_code: paperCode,
        language: formDetails.language.map((lang) =>
          lang === "en" ? "en" : "hi",
        ),
        question_count: formDetails.question_count,
        total_question: formDetails.total_question,
        total_score: formDetails.total_score,
        per_question_mark: perQuestionMarks,
        question_shuffle: formDetails.question_shuffle,
        option_shuffle: formDetails.option_shuffle,
        negative_marking: formDetails.negative_marking,
        negative_marking_score: `-${Math.abs(
          formDetails.negative_marking_score,
        )}`,
        exam_instant_result: formDetails.exam_instant_result,
        exam_pin: formDetails.exam_pin,
        time_bound: formDetails.time_bound,
        exam_instruction_en: formDetails.exam_instructions.en,
        exam_instruction_hi: formDetails.exam_instructions.hi,
        enable_submit: formDetails.enable_submit || "0",
        genral_instruction_en: formDetails.genral_instruction.en,
        genral_instruction_hi: formDetails.genral_instruction.hi,
        duration: formDetails.duration,
        start_date: formDetails.start_date,
        start_time: formDetails.start_time,
        is_submit_on_time: formDetails.is_submit_on_time,
        subject_selection: formDetails.subject_selection,
        direction: formDetails.direction,
        end_time: formDetails.end_time,
        slot_id: formDetails.slot_value || null,
        marking_system_id: formDetails.marking_system || null,
        exam_template: formDetails.exam_template,
        exam_format:
          formDetails.exam_template === "ssc/railway"
            ? formDetails.exam_format
            : null,
        subject_wise: showSubjectWiseDuration || null,
        calculator_enable: formDetails.calculator_enable,
        before_instruction: formDetails.before_instruction,
        marking_system_id: formDetails.marking_system || null,
        question_mark_system: questionMarkSystem || null,
        subjectDuration:
          showSubjectWiseDuration === "yes"
            ? (subjectDurations || []).filter((item) =>
              selectedSubject.some(
                (subId) => String(subId) === String(item.subject_id)
              )
            )
            : [],
        exam_type: "main",
        pin_enable: pinEnable,
        randomized_question_pick: formDetails.randomized_question_pick,
        count: formDetails.subject_question_count,
        section_count: formDetails.section_count,
        center_feedback: formDetails.center_feedback,
        keyboard_enable: formDetails.keyboard_enable === "yes" || formDetails.keyboard_enable === true,
      };

      formData.append("exam", JSON.stringify(examData));
      formData.append("file", thumbnailImage);
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Exam updated successfully!");

        setTimeout(() => {
          navigate(`/admin/examdashboard/${response.data.exam.id}`);
        }, 2000);
      } else {
        toast.error(`Exam is not updated! ${response.data.message}`);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error(error.response.data.message);
      // toast.error("Exam is not updated!");
    }
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/all/active`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          },
        );

        // Ensure that the API response contains the 'batch' property
        if (response.data && response.data.courses) {
          setCourses(response.data.courses);
        } else {
          console.error("Invalid API response format:", response);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [decryptedToken]);

  const fetchBatches = async (selectedCourse) => {
    const data = {
      batch: {
        course_ids: selectedCourse,
      },
    };

    try {
      const response = await axios.post(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_id/${selectedCourse}`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      if (response) {
        console.log("selectedCourse", response.data.batches);
        setBatches(response.data.batches);
      } else {
        console.error("Failed to fetch batches data:", response);
      }

      // if (response.data && response.data.batches) {
      //   setBatches(response.data.batches);
      // } else {
      //   console.error("Invalid API response format:", response);
      // }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    fetchBatches(selectedCourse);
  }, [selectedCourse]);

  const fetchSubjects = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/active/list`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      if (response.data && response.data.subjects) {
        const filteredSubjects = (response.data.subjects || []).filter(
          (sub) => sub.type === "subject"
        );
        // setSubjects(response.data.subjects);
        setSubjects(filteredSubjects);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      if (selectedCourse && selectedBatch) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course/batch/new`,
          {
            center: {
              courseId: selectedCourse,
              batchId: selectedBatch,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        setCenter(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, [selectedCourse, selectedBatch]);

  function formatTime(timeString) {
    // Extract hours and minutes from the time string
    const [hours, minutes] = timeString.split(":");
    return `${hours}:${minutes}`;
  }
  const cleanHTML = (html) => {
    if (!html) return html;
    return html
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>/gi, "")
      .replace(/(<[^>]+>)\s+(?=<)/g, "$1")
      .replace(/(>)\s+(<)/g, "$1$2")
      .replace(/\s{2,}/g, " ")
      .replace(/&nbsp;/g, " ")
      .trim();
  };
  const normalizeQuillHTML = (html) => {
    if (!html) return html;
    return html
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi, "")
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ol>)/gi, "")
      .replace(/(<\/li>)\s*<p[^>]*>(\s*)<\/p>/gi, "$1")
      .replace(/<p>\s*<br>\s*<\/p>/gi, "");
  };
  const fetchDataFromAPI = async (rowId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200 && response.data.success) {
        const exam = response.data.exam;

        // Convert the incoming date string to a Date object
        const incomingDate = new Date(exam.start_date);

        // incomingDate.setDate(incomingDate.getDate() + 1);
        incomingDate.setDate(incomingDate.getDate());

        // Format the date to 'YYYY-MM-DD' string
        const startDate = incomingDate.toISOString().split("T")[0];
        const startTime = formatTime(exam.start_time);
        const endTime = exam.end_time ? formatTime(exam.end_time) : null;
        setFormDetails({
          ...formDetails,
          center_id: exam.center_id,
          slot_value: exam.slot_id,
          marking_system: exam.marking_system_id,
          course_id: exam.course,
          batch_ids: exam.batch,
          exam_name: exam.exam_name,
          language: exam.language.map((lang) => lang.code || lang),
          question_count: exam.question_count,
          per_question_mark: perQuestionMarks,
          total_question: exam.total_question,
          total_score: exam.total_score,
          is_submit_on_time: exam.is_submit_on_time === true ? "yes" : "no",
          subject_selection: exam.subject_selection,
          direction: exam.direction,
          question_shuffle: exam.question_shuffle,
          option_shuffle: exam.option_shuffle,
          negative_marking: exam.negative_marking,
          negative_marking_score: exam.negative_marking_score.toString(),
          exam_instant_result: exam.exam_instant_result,
          randomized_question_pick: exam.randomized_question_pick,
          section_count: exam.sectiontcount,
          subject_question_count: exam?.subjectcount,
          exam_pin: exam.exam_pin,
          time_bound: exam.time_bound,
          enable_submit: exam.enable_submit || "0",
          exam_instructions: {
            // en: exam.exam_instruction_en.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
            // hi: exam.exam_instruction_hi.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
            en: cleanHTML(normalizeQuillHTML(exam.exam_instruction_en)),
            hi: cleanHTML(normalizeQuillHTML(exam.exam_instruction_hi)),
          },
          genral_instruction: {
            en: cleanHTML(normalizeQuillHTML(exam.genral_instruction_en)),
            hi: cleanHTML(normalizeQuillHTML(exam.genral_instruction_hi)),
            // en: exam.genral_instruction_en.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
            // hi: exam.genral_instruction_hi.replace(
            //   /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
            //   ""
            // ),
          },
          duration: exam.duration,
          start_date: startDate,
          start_time: startTime,
          end_time: endTime,
          calculator_enable: exam.calculator_enable || "",
          before_instruction: exam.before_instruction || "",
          // marking_system:marking_system,
          exam_template: exam.exam_template,
          exam_format: exam.exam_format || "",
          center_feedback: exam.center_feedback || "no",
          keyboard_enable: exam.keyboard_enable === true || exam.keyboard_enable === "yes" ? "yes" : "no",
        });
        setSelectedCourse(exam.course.map((c) => c.id));
        setPerQuestionMarks(exam.per_question_mark);
        setSelectedBatch(exam.batch.map((b) => b.id));
        setExamName(exam.exam_name);
        setPaperCode(exam.paper_code);
        setSelectedSubject(exam.subjects.map((subject) => subject.id));
        setSelectedSubjectName(exam.subjects);
        setSelectedCenter(exam.center.map((center) => center.id));
        setThumbnailImage(exam.image_url);
        setThumbnailImagePreview(exam.image_url);
        setQuestionMarkSystem(exam.question_mark_system);
        setShowSubjectWiseDuration(exam.subject_wise);
        setSubjectDurations(exam.subjectduration);
        setPinEnable(exam?.pin_enable || "on");
      } else {
        toast.error("Failed to fetch exam details.");
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
      toast.error("An error occurred while fetching exam details.");
    }
  };
  const initialDataLoaded = useRef(false);
  useEffect(() => {
    if (rowId) {
      fetchDataFromAPI(rowId).then(() => {
        initialDataLoaded.current = true; // Mark initial load complete
      });
    }
  }, [rowId]);

  const [loading, setLoading] = useState(false);

  const handleAutoGeneratePin = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/generate/unique/pin`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      handleFormChange("exam_pin", res.data?.exam_pin);
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate exam pin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1}  ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h72vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) =>
                    setExamName(sanitizeInput(e.target.value, "textInput"))
                  }
                  value={examName}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Paper Code
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) =>
                    setPaperCode(sanitizeInput(e.target.value, "textInput"))
                  }
                  value={paperCode}
                  placeholder="Type Here"
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="courses-multiple"
                  options={courses}
                  getOptionLabel={(option) => option.course_name}
                  value={courses.filter((c) => selectedCourse.includes(c.id))}
                  onChange={(event, newValue) =>
                    setSelectedCourse(newValue.map((c) => c.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="courses"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Batch <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  {selectedCourse?.length > 0 && batches?.length > 0 && (
                    <Button
                      size="small"
                      color="primary"
                      style={{ textTransform: "none", fontSize: "12px", padding: "0 4px", minWidth: "auto" }}
                      onClick={() => {
                        if (Array.isArray(selectedBatch) && selectedBatch.length === batches.length) {
                          setSelectedBatch([]);
                        } else {
                          setSelectedBatch(batches.map((bat) => bat.id));
                        }
                      }}
                    >
                      {Array.isArray(selectedBatch) && selectedBatch.length === batches.length
                        ? "Deselect All"
                        : "Select All"}
                    </Button>
                  )}
                </div>

                <Autocomplete
                  multiple
                  id="batches-multiple"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((b) => selectedBatch.includes(b.id))}
                  onChange={(event, newValue) =>
                    setSelectedBatch(newValue.map((b) => b.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="batches"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Subject <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={subjects}
                  getOptionLabel={(option) => option.subject_name}
                  value={subjects.filter((sub) =>
                    selectedSubject.includes(sub.id),
                  )}
                  onChange={handleSubjectChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
                  ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={center}
                  getOptionLabel={(option) =>
                    `${option.center_code} - ${option.center_name}`
                  }
                  value={center?.filter((sub) =>
                    selectedCenter?.includes(sub.id),
                  )}
                  onChange={handleCenterChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>
            </div>

            {/* Subject Durations (IP MAT only) - Directly below Branch Code */}
            {formDetails.exam_template === "ipmat" &&
              selectedSubject?.length > 0 && (
                <div
                  className={`${classes.dflex} ${classes.w100} ${classes.justifyspacebetween} ${classes.mt1} `}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexwrapwrap} ${classes.w75} ${classes.gap10}`}
                  >
                    {subjects
                      .filter((sub) => selectedSubject.includes(sub.id))
                      .map((sub, idx) => (
                        <div
                          key={sub.id || idx}
                          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w32}`}
                        >
                          <FormLabel
                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                          >
                            {sub.subject_name} Duration (mins){" "}
                            <span className={classes.textcolorred}>*</span>
                          </FormLabel>
                          <TextField
                            type="number"
                            variant="outlined"
                            value={
                              subjectDurations?.find(
                                (item) =>
                                  String(item.subject_id) === String(sub.id),
                              )?.duration ?? ""
                            }
                            onChange={(e) =>
                              handleSubjectDurationChange(
                                sub.id,
                                e.target.value,
                              )
                            }
                            placeholder="Type Here"
                          />
                        </div>
                      ))}
                  </div>
                </div>
              )}

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Languages <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="language-label"
                  id="language"
                  multiple
                  open={languageMenuOpen}
                  onOpen={handleLanguageMenuToggle}
                  onClose={handleLanguageMenuToggle}
                  value={formDetails.language}
                  onChange={(e) => {
                    handleFormChange("language", e.target.value);
                    handleLanguageMenuToggle(); // Close the dropdown after selection
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((code) => (code === "en" ? "English" : "Hindi"))
                      .join(", ")
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem value="hi">Hindi</MenuItem>
                  <MenuItem value="en">English</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Pannel Template <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Select
                  labelId="category-label"
                  id="state"
                  required
                  value={formDetails.exam_template}
                  onChange={(e) =>
                    handleFormChange("exam_template", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>

                  {/* <MenuItem value={"default"}>Default</MenuItem> */}
                  <MenuItem value={"ssc/railway"}>IIT</MenuItem>
                  <MenuItem value={"ipmat"}>IP MAT</MenuItem>
                  {/* <MenuItem value={"coding"}>Coding</MenuItem> */}
                  {/* <MenuItem value={"cat"}>Banking</MenuItem> */}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                {formDetails.exam_template === "ssc/railway" && (
                  <>
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam Format <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Autocomplete
                      id="exam-format-autocomplete"
                      options={["NEET", "JEE Mains", "JEE Advance(48)", "JEE Advance(51)", "JEE Advance(54)", "JEE Advance(57)", "Other"]}
                      value={formDetails.exam_format || null}
                      onChange={(event, newValue) => {
                        handleExamFormatChange(newValue || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select Format"
                        />
                      )}
                    />
                  </>
                )}
                {formDetails.exam_template === "ipmat" && (
                  <>
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Randomized Question Pick{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="randomized-pick-label"
                      id="randomized-pick"
                      value={formDetails.randomized_question_pick || ""}
                      onChange={(e) =>
                        handleFormChange(
                          "randomized_question_pick",
                          e.target.value,
                        )
                      }
                      displayEmpty
                      required
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                    </Select>
                  </>
                )}
              </div>
            </div>
            {/* ── IIT (ssc/railway) Fields ── */}
            {formDetails.exam_template === "ssc/railway" && (
              <>
                {/* IIT Row 4: Question Count | Total Score | Per Question Mark */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Count <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      onChange={(e) =>
                        handleFormChange("question_count", e.target.value)
                      }
                      value={formDetails.question_count}
                      placeholder="Type Here"
                    />
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Total Score <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      onChange={(e) =>
                        handleFormChange("total_score", e.target.value)
                      }
                      value={formDetails.total_score}
                      placeholder="Type Here"
                    />
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Per Question Mark
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      value={
                        perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"
                      }
                      disabled
                    />
                  </div>
                </div>

                {/* IIT Row 5: Question Mark System | Negative Marking | Negative Marking Score */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Mark System <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={questionMarkSystem}
                      onChange={(e) => {
                        handleFormChange("question_mark_system", e.target.value);
                        setQuestionMarkSystem(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="same"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("same")}
                          />
                        }
                        label="Same"
                      />
                      <FormControlLabel
                        value="different"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("different")}
                          />
                        }
                        label="Different"
                      />
                    </RadioGroup>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="negativemarking-label"
                      id="negativemarking"
                      value={
                        questionMarkSystem === "different"
                          ? "no"
                          : formDetails.negative_marking
                      }
                      onChange={(e) =>
                        handleFormChange("negative_marking", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                      disabled={questionMarkSystem === "different"}
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value={"yes"}>Yes</MenuItem>
                      <MenuItem value={"no"}>No</MenuItem>
                    </Select>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking Score <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      required
                      value={
                        questionMarkSystem === "different" ||
                          formDetails.negative_marking === "no"
                          ? 0
                          : `-${String(
                            formDetails.negative_marking_score,
                          ).replace(/^[-]+/, "")}`
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9.]/g, "");
                        if (formDetails.negative_marking === "yes") {
                          handleFormChange("negative_marking_score", value);
                        } else {
                          handleFormChange("negative_marking_score", "0");
                        }
                      }}
                      placeholder="Type Here"
                      disabled={
                        questionMarkSystem === "different" ||
                        formDetails.negative_marking === "no"
                      }
                    />
                  </div>
                </div>
              </>
            )}

            {/* ── IPMat Fields ── */}
            {formDetails.exam_template === "ipmat" && (
              <>
                {/* IPMat Row 4:
                    if Randomized Question Pick == yes: Question Pick Count | Total Question Count | Total Score
                    if Randomized Question Pick == no: Question Count | Total Score | Per Question Mark */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  {formDetails.randomized_question_pick === "yes" ? (
                    <>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Question Pick Count <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("question_count", e.target.value)
                          }
                          value={formDetails.question_count}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Total Question Count <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("total_question", e.target.value)
                          }
                          value={formDetails.total_question}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Total Score <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("total_score", e.target.value)
                          }
                          value={formDetails.total_score}
                          placeholder="Type Here"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Question Count <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("question_count", e.target.value)
                          }
                          value={formDetails.question_count}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Total Score <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("total_score", e.target.value)
                          }
                          value={formDetails.total_score}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Per Question Mark
                        </FormLabel>
                        <TextField
                          type="text"
                          variant="outlined"
                          value={
                            perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"
                          }
                          disabled
                        />
                      </div>
                    </>
                  )}
                </div>

                {/* Extra row for Per Question Mark when Randomized Question Pick is yes */}
                {formDetails.randomized_question_pick === "yes" && (
                  <div
                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                  >
                    <Typography
                      className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                      variant="h6"
                      display="inline"
                    ></Typography>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Per Question Mark
                      </FormLabel>
                      <TextField
                        type="text"
                        variant="outlined"
                        value={
                          perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"
                        }
                        disabled
                      />
                    </div>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                    ></div>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                    ></div>
                  </div>
                )}

                {/* IPMat Row 5: Question Mark System | Negative Marking | Negative Marking Score */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Mark System <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={questionMarkSystem}
                      onChange={(e) => {
                        handleFormChange("question_mark_system", e.target.value);
                        setQuestionMarkSystem(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="same"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("same")}
                          />
                        }
                        label="Same"
                      />
                      <FormControlLabel
                        value="different"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("different")}
                          />
                        }
                        label="Different"
                      />
                    </RadioGroup>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="ipmat-negativemarking-label"
                      id="ipmat-negativemarking"
                      value={
                        questionMarkSystem === "different"
                          ? "no"
                          : formDetails.negative_marking
                      }
                      onChange={(e) =>
                        handleFormChange("negative_marking", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                      disabled={questionMarkSystem === "different"}
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value={"yes"}>Yes</MenuItem>
                      <MenuItem value={"no"}>No</MenuItem>
                    </Select>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking Score <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      required
                      value={
                        questionMarkSystem === "different" ||
                          formDetails.negative_marking === "no"
                          ? 0
                          : `-${String(
                            formDetails.negative_marking_score,
                          ).replace(/^[-]+/, "")}`
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9.]/g, "");
                        if (formDetails.negative_marking === "yes") {
                          handleFormChange("negative_marking_score", value);
                        } else {
                          handleFormChange("negative_marking_score", "0");
                        }
                      }}
                      placeholder="Type Here"
                      disabled={
                        questionMarkSystem === "different" ||
                        formDetails.negative_marking === "no"
                      }
                    />
                  </div>
                </div>
              </>
            )}
          </div>

          {/* ── Section 2: Other Details ── */}
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            {/* Row 1: Question Shuffle | Option Shuffle | Time Bound */}
            <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Features
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Question Shuffle <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="question-shuffle-label"
                  id="question-shuffle"
                  value={formDetails.question_shuffle}
                  onChange={(e) =>
                    handleFormChange("question_shuffle", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Option Shuffle <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="option-shuffle-label"
                  id="option-shuffle"
                  value={formDetails.option_shuffle}
                  onChange={(e) =>
                    handleFormChange("option_shuffle", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Time Bound <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="time-bound-label"
                  id="time_bound"
                  value={formDetails.time_bound}
                  onChange={(e) =>
                    handleFormChange("time_bound", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>
            </div>

            {/* Row 2: Calculator Enable | Keyboard Enable | Center Feedback */}
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Calculator Enable <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="calculator-enable-label"
                  id="calculator-enable"
                  value={formDetails.calculator_enable}
                  onChange={(e) =>
                    handleFormChange("calculator_enable", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                      Select Here
                    </em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Keyboard Enable <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="keyboard-enable-label"
                  id="keyboard-enable"
                  value={formDetails.keyboard_enable || "yes"}
                  onChange={(e) =>
                    handleFormChange("keyboard_enable", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Center Feedback <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="center-feedback-autocomplete"
                  options={["yes", "no"]}
                  getOptionLabel={(option) =>
                    option.charAt(0).toUpperCase() + option.slice(1)
                  }
                  value={formDetails.center_feedback || "no"}
                  onChange={(event, newValue) => {
                    handleFormChange("center_feedback", newValue || "no");
                  }}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="center_feedback"
                      variant="outlined"
                      placeholder="Select Here"
                    />
                  )}
                />
              </div>
            </div>

            {/* Row 3: Exam Instant Result | Exam Instructions before | Exam PIN (in 1 col) */}
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Instant Result <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="exam-instant-result-label"
                  id="exam-instant-result"
                  value={formDetails.exam_instant_result}
                  onChange={(e) =>
                    handleFormChange("exam_instant_result", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                  <MenuItem value={"with_answer"}>With Answers</MenuItem>
                  <MenuItem value={"without_answer"}>Without Answers</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Instructions before{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="before-instruction-label"
                  id="before-instruction"
                  value={formDetails.before_instruction}
                  onChange={(e) =>
                    handleFormChange("before_instruction", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                      Select Here
                    </em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: "24px",
                  }}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Exam PIN{" "}
                    {pinEnable === "on" && (
                      <span className={classes.textcolorred}>*</span>
                    )}
                  </FormLabel>
                  <RadioGroup
                    row
                    value={pinEnable}
                    onChange={(e) => setPinEnable(e.target.value)}
                    className={classes.radiocolor}
                  >
                    <FormControlLabel
                      value="on"
                      control={<Radio size="small" />}
                      label="On"
                      style={{ marginRight: 6 }}
                    />
                    <FormControlLabel
                      value="off"
                      control={<Radio size="small" />}
                      label="Off"
                      style={{ margin: 0 }}
                    />
                  </RadioGroup>
                </div>
                {pinEnable === "on" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <TextField
                      type="text"
                      variant="outlined"
                      required
                      placeholder="****"
                      value={formDetails.exam_pin}
                      onChange={(e) =>
                        handleFormChange(
                          "exam_pin",
                          sanitizeInput(e.target.value, "Pincode"),
                        )
                      }
                      inputProps={{ maxLength: 4 }}
                      error={
                        formDetails.exam_pin?.length > 0 &&
                        formDetails.exam_pin.length !== 4
                      }
                      helperText={
                        formDetails.exam_pin?.length > 0 &&
                          formDetails.exam_pin.length !== 4
                          ? "Must be 4 digits"
                          : ""
                      }
                      style={{ flex: 1 }}
                    />
                    <Button
                      onClick={handleAutoGeneratePin}
                      className={classes.custombtnblue}
                      disabled={loading}
                      style={{
                        whiteSpace: "nowrap",
                        height: "40px",
                        padding: "0 10px",
                        fontSize: "12px",
                        minWidth: "auto",
                      }}
                    >
                      {loading ? "..." : "Generate"}
                    </Button>
                  </div>
                ) : (
                  <TextField
                    type="text"
                    variant="outlined"
                    disabled
                    placeholder="PIN Disabled"
                    value=""
                  />
                )}
              </div>
            </div>

            {/* Row 4 (IP MAT): Exam Direction | Subject Selection Before Exam Start | Submission lock */}
            {formDetails.exam_template === "ipmat" && (
              <>
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam Direction <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="exam-direction-label"
                      id="exam-direction"
                      value={formDetails.direction}
                      onChange={(e) =>
                        handleFormChange("direction", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                          Select Here
                        </em>
                      </MenuItem>
                      <MenuItem value={"unidirectional"}>Unidirectional</MenuItem>
                      <MenuItem value={"bidirectional"}>Bidirectional</MenuItem>
                    </Select>
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Subject Selection Before Exam Start <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="exam-section-selection-label"
                      id="exam-section-selection"
                      value={formDetails.subject_selection}
                      onChange={(e) =>
                        handleFormChange("subject_selection", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                          Select Here
                        </em>
                      </MenuItem>
                      <MenuItem value={"yes"}>Yes</MenuItem>
                      <MenuItem value={"no"}>No</MenuItem>
                    </Select>
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Submission lock <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="submission-lock-label"
                      id="submission-lock"
                      value={formDetails.is_submit_on_time}
                      onChange={(e) =>
                        handleFormChange("is_submit_on_time", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value={"no"}>Yes</MenuItem>
                      <MenuItem value={"yes"}>No</MenuItem>
                    </Select>
                  </div>
                </div>

                {/* Row 5 (IP MAT): Subject Wise Submit */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <input
                      type="hidden"
                      name="subject_wise"
                      value={showSubjectWiseDuration}
                    />
                    {/* <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Subject Wise Submit{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={showSubjectWiseDuration}
                      onChange={handleQuestionMarkSystemChange}
                      disabled
                    >
                      <FormControlLabel
                        value="no"
                        control={<Radio disabled />}
                        label="No"
                      />
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                      />
                    </RadioGroup> */}
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                </div>
              </>
            )}
          </div>

          {/* ── Section 3: Instructions ── */}
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Instructions
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Genral Instructions for {lang} language: */}
                      Enter your Exam Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      style={{
                        height: "500px",
                        paddingTop: "1rem",
                        paddingBottom: "3rem",
                      }}
                      value={formDetails.genral_instruction[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          genral_instruction: {
                            ...prev.genral_instruction,
                            [lang]: content,
                          },
                        }));
                      }}
                      modules={quillModules}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.mt2}  ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Exam Instructions for {lang} language: */}
                      Enter your Genral Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      // readOnly
                      value={formDetails.exam_instructions[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          exam_instructions: {
                            ...prev.exam_instructions,
                            [lang]: content,
                          },
                        }));
                      }}
                      // readOnly={true}
                      modules={quillModules}
                      // modules={{
                      //   ...quillModules,
                      //   toolbar: {
                      //     ...quillModules.toolbar,
                      //     container: quillModules.toolbar?.container,
                      //     handlers: {}, // override all handlers so nothing works
                      //   },
                      // }}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                *Other Details
              </Typography>

              {/* ipmat: 4 fields in one row with w24 */}
              {formDetails.exam_template === "ipmat" ? (
                <>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Duration in minutes <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      required
                      value={formDetails.duration}
                      onChange={(e) => handleFormChange("duration", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Date <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="date"
                      variant="outlined"
                      required
                      value={formDetails.start_date}
                      onChange={(e) => handleFormChange("start_date", e.target.value)}
                      placeholder="Select Date"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Time <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="time"
                      variant="outlined"
                      required
                      value={formDetails.start_time}
                      onChange={(e) => handleFormChange("start_time", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      End Time <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="time"
                      variant="outlined"
                      required
                      value={formDetails.end_time}
                      onChange={(e) => handleFormChange("end_time", e.target.value)}
                      placeholder="Type Here"
                      disabled={formDetails.time_bound === "yes"}
                      inputProps={{
                        min: formDetails.start_time || undefined,
                      }}
                    />
                  </div>
                </>
              ) : (
                /* non-ipmat: original 5-field layout */
                <>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Duration in minutes <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      required
                      value={formDetails.duration}
                      onChange={(e) => handleFormChange("duration", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Enable submit in minutes{" "}
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      required
                      value={formDetails.enable_submit}
                      onChange={(e) => handleFormChange("enable_submit", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Date <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="date"
                      variant="outlined"
                      required
                      value={formDetails.start_date}
                      onChange={(e) => handleFormChange("start_date", e.target.value)}
                      placeholder="Select Date"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Time <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="time"
                      variant="outlined"
                      required
                      value={formDetails.start_time}
                      onChange={(e) => handleFormChange("start_time", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                </>
              )}
            </div>

            {/* End Time row — only for non-ipmat (ipmat has it in row above) */}
            {formDetails.exam_template !== "ipmat" && (
              <div className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}>
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                  <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                    End Time <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    type="time"
                    variant="outlined"
                    required
                    value={formDetails.end_time}
                    onChange={(e) => handleFormChange("end_time", e.target.value)}
                    placeholder="Type Here"
                    disabled={formDetails.time_bound === "yes"}
                    inputProps={{
                      min: formDetails.start_time || undefined,
                    }}
                  />
                </div>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}></div>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}></div>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}></div>
              </div>
            )}

            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
                 <Typography
                   className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                   variant="h6"
                   display="inline"
                 ></Typography>
                 <div
                   className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}
                 >
                   <FormLabel
                     className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                   >
                     Select Slot <span className={classes.textcolorred}>*</span>
                   </FormLabel>
                   <Select
                     value={formDetails.slot_value}
                     onChange={(e) =>
                       handleFormChange("slot_value", e.target.value)
                     }
                     displayEmpty
                     required
                     variant="outlined"
                   >
                     <MenuItem value="" disabled>
                       Select a slot
                     </MenuItem>
                     {slotDropdownFieldData?.centers_slot?.map((slot, index) => (
                       <MenuItem key={index} value={slot?.id}>
                         {slot?.slot_name}
                       </MenuItem>
                     ))}
                   </Select>
                 </div>
                 <div
                   className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                 ></div>
                 <div
                   className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                 ></div>
               </div> */}
          </div>

          {formDetails.randomized_question_pick === "yes" &&
            (formDetails.exam_template === "ssc/railway" ||
              formDetails.exam_template === "ipmat") && (
              <QuestionPickTable
                classes={classes}
                formDetails={formDetails}
                handleFormChange={handleFormChange}
                selectedSubject={selectedSubject}
                setSelectedSubjectSLength={setSelectedSubjectSLength}
              />
            )}
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleCancel}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default EditExamForm;
